import React, { useState } from 'react';
import { SettingsIcon, ZapIcon } from 'lucide-react';
export function AutoAdjustmentSettings({
  enabled,
  onToggle
}) {
  const [settings, setSettings] = useState({
    turnOffNonEssential: true,
    adjustAC: true,
    limitHighPower: false
  });
  return <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-15">
      <div className="flex items-center justify-between mb-4" data-id="element-16">
        <h2 className="text-lg font-semibold flex items-center" data-id="element-17">
          <SettingsIcon size={20} className="mr-2 text-green-600" data-id="element-18" />
          Automatic Adjustments
        </h2>
        <label className="relative inline-flex items-center cursor-pointer" data-id="element-19">
          <input type="checkbox" checked={enabled} onChange={e => onToggle(e.target.checked)} className="sr-only peer" data-id="element-20" />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600" data-id="element-21"></div>
        </label>
      </div>
      <p className="text-sm text-gray-600 mb-4" data-id="element-22">
        Automatically adjust device settings when approaching budget limits
      </p>
      <div className="space-y-4" data-id="element-23">
        <div className="flex items-start justify-between p-3 bg-gray-50 rounded-lg" data-id="element-24">
          <div className="flex-1" data-id="element-25">
            <p className="font-medium text-sm" data-id="element-26">
              Turn Off Non-Essential Devices
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-27">
              Automatically turn off devices like TV, entertainment systems when
              usage exceeds 80%
            </p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer ml-3" data-id="element-28">
            <input type="checkbox" checked={settings.turnOffNonEssential} onChange={e => setSettings({
            ...settings,
            turnOffNonEssential: e.target.checked
          })} disabled={!enabled} className="sr-only peer" data-id="element-29" />
            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600 peer-disabled:opacity-50" data-id="element-30"></div>
          </label>
        </div>
        <div className="flex items-start justify-between p-3 bg-gray-50 rounded-lg" data-id="element-31">
          <div className="flex-1" data-id="element-32">
            <p className="font-medium text-sm" data-id="element-33">Adjust AC Temperature</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-34">
              Increase AC temperature by 2-3°C during high usage periods
            </p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer ml-3" data-id="element-35">
            <input type="checkbox" checked={settings.adjustAC} onChange={e => setSettings({
            ...settings,
            adjustAC: e.target.checked
          })} disabled={!enabled} className="sr-only peer" data-id="element-36" />
            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600 peer-disabled:opacity-50" data-id="element-37"></div>
          </label>
        </div>
        <div className="flex items-start justify-between p-3 bg-gray-50 rounded-lg" data-id="element-38">
          <div className="flex-1" data-id="element-39">
            <p className="font-medium text-sm" data-id="element-40">Limit High Power Devices</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-41">
              Prevent high-power devices from running simultaneously
            </p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer ml-3" data-id="element-42">
            <input type="checkbox" checked={settings.limitHighPower} onChange={e => setSettings({
            ...settings,
            limitHighPower: e.target.checked
          })} disabled={!enabled} className="sr-only peer" data-id="element-43" />
            <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600 peer-disabled:opacity-50" data-id="element-44"></div>
          </label>
        </div>
      </div>
      {enabled && <div className="mt-4 p-3 bg-green-50 rounded-lg flex items-start" data-id="element-45">
          <ZapIcon size={16} className="text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-46" />
          <p className="text-sm text-green-700" data-id="element-47">
            Automatic adjustments are active. The system will help you stay
            within your budget by making smart decisions.
          </p>
        </div>}
    </div>;
}